import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/pacman/Index.vue')
const FitPage = () => import('../activity/pacman/Fit.vue')
const IndexDouyin = () => import('../activity/pacman/douyin/Index.vue')
const RewardsDouyin = () => import('../activity/pacman/douyin/Rewards.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/pacman',
  name: 'activity_pacman',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '吃豆人大赛',
  },
}

export const fitRoute: RouteConfig = {
  path: '/activity/pacman-fit',
  name: 'activity_pacman_fit',
  component: FitPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '吃豆人Fit',
  },
}

export const indexDouyinRoute: RouteConfig = {
  path: '/activity/pacman-douyin',
  name: 'activity_pacman_douyin',
  component: IndexDouyin,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '“豆门”集合',
  },
}

export const rewardsDouyinRoute: RouteConfig = {
  path: '/activity/pacman-douyin/rewards',
  name: 'activity_pacman_douyin_rewards',
  component: RewardsDouyin,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '我的奖品',
  },
}

export default [indexRoute, fitRoute, indexDouyinRoute, rewardsDouyinRoute]
